import React from 'react';
import { SparkIcon } from '@spark';

const TAB_COUNT_STYLE = {
    marginLeft: 4,
    fontWeight: 400,
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    alignItems: 'center',
};

export const formatCount = (count) => {
    if (count === undefined || count === null) return '0';
    if (count < 1000) return count.toString();
    if (count < 1000000) return `~${(count / 1000).toFixed((count / 1000) % 1 === 0 ? 0 : 1)}k`;
    return `~${(count / 1000000).toFixed((count / 1000000) % 1 === 0 ? 0 : 1)}M`;
};

export function DataEditorTabLabel({ label, count, isLoading = false }) {
    return (
        <span className="fs-unmask">
            {label}
            <span
                style={TAB_COUNT_STYLE}
                role={isLoading ? 'status' : undefined}
                aria-label={isLoading ? 'Loading' : undefined}
            >
                {isLoading ? (
                    <SparkIcon slug="loader" size="small" className="spark-icon-spin" />
                ) : (
                    ` (${formatCount(count)})`
                )}
            </span>
        </span>
    );
}
